module.exports = __webpack_public_path__ + "media/images/frontend/lamberet/color-separator-505e1f16fb2847b21957256e2913d91c.png";